import { IconType, Heading, Button, Icon, InputPin } from '@lmc/ui-kit'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { NAMESPACE } from 'locale'
import { selfServeConstants } from 'locale/selfServe'
import { Text } from '@lmc/ui-kit/src/general'
import { useDispatch, useSelector } from 'react-redux'
import { User } from '@lmc/ts-common'
import { FC, useState } from 'react'
import Operations from 'operations'
import { LogoutButton } from './LogoutButton'
import { useCreateTemplates } from './hooks'
import { Logo } from './Logo'

type Props = {
  homeId: string
}

export const StepPin: FC<Props> = ({ homeId }) => {
  const { t } = useTranslation(NAMESPACE.SELF_SERVE)

  const user = useSelector(
    (state: { global: { user: User } }) => state.global.user
  )

  const [loading, setLoading] = useState(false)

  const dispatch = useDispatch()

  const [pin, setPin] = useState<string>()

  const refetchCarer = async () => {
    window.location.reload()
  }

  const { createTemplateData } = useCreateTemplates(homeId, refetchCarer)

  const activatePin = async () => {
    createTemplateData()
    setLoading(true)
    const res = await dispatch(
      Operations.updateListItem({
        listId: 'carers',
        itemId: user?.id,
        successMsg: 'Set the PIN',
        // TODO double check after API update
        json: {
          pin,
          pin_confirm: pin
        }
      })
    )

    if (res) {
      useCreateTemplates(homeId)
    }
    setLoading(false)
  }

  const isValidPin = pin?.length === 4

  return (
    <>
      <Icon
        customIcon={IconType.CleanLargeLogoIcon}
        style={{
          height: '100vh',
          width: 1000,
          position: 'absolute',
          right: 0,
          bottom: 0,
          top: '-20px'
        }}
      />
      <Wrapper>
        <TopWrapper>
          <Logo />
          <LogoutButton />
        </TopWrapper>
        <CenterWrapper>
          <StyledHeading level={1}>
            {t(selfServeConstants.SET_A_PIN)}
          </StyledHeading>
          <StyledText>{t(selfServeConstants.YOUR_SECURE_CODE)}</StyledText>
          <PinWrapper>
            <InputPin onComplete={(e) => setPin(e)} />
          </PinWrapper>
          <ButtonWrapper>
            <StyledButton
              variant="primary"
              size="large"
              onClick={activatePin}
              isLoading={loading}
              disabled={!isValidPin}
            >
              {t(selfServeConstants.FINISH)}
            </StyledButton>
            <StyledTextDesc>
              {t(selfServeConstants.STEP_X_OF_X, { from: 3, to: 3 })}
            </StyledTextDesc>
          </ButtonWrapper>
        </CenterWrapper>
      </Wrapper>
    </>
  )
}

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.color.background.primary};
  height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 100px 160px;
  ${({ theme }) => theme.mediaQueries.mobileDown} {
    padding: 10px;
  }
`

const CenterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: auto;
  margin-top: auto;
`

const StyledHeading = styled(Heading)`
  color: ${({ theme }) => theme.color.neutral.color11};
  font-weight: 800;
  font-size: 54px;
  line-height: 59px;
  max-width: 800px;
  font-family: gilroy;
`

const StyledText = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color11};
  font-size: 24px;
  font-weight: 400;
  line-height: 32px;
  opacity: 0.7;
  max-width: 960px;
  margin-top: 10px;
  margin-bottom: 40px;
`

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 30px;
`

const PinWrapper = styled.div`
  z-index: 10;
`

const StyledTextDesc = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color11};
  margin-top: 5px;
  margin-left: 20px;
`

const StyledButton = styled(Button)`
  width: max-content;
  z-index: 10;
`
const TopWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`
